import getCableConsumer from "../consumer";

export const STORE_REQUEST_CABLE_EVENT = "store_request_cable_event";

export function createStoreRequestsSubscription(dispatch) {
  return getCableConsumer().subscriptions.create("Store::RequestsChannel", {
    received(data) {
      if (!dispatch || !data?.action) return;
      dispatch({ type: STORE_REQUEST_CABLE_EVENT, payload: data });
    },
  });
}
